// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7860cb60","703":"1068c31d","787":"265bbd93"}[chunkId] + ".chunk.js";
};